module.exports = __webpack_public_path__ + "static/media/ijoystick.dd9da1c3.svg";